import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type User from "./User";

@Model()
class UpsellRegistration extends ApplicationRecord {
  static jsonapiType = "upsell_registrations";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() registeredUntil: string;

  @Attr() service: string;

  @BelongsTo() user: User;

  @Attr() userId: number;

  static notArchived() {
    return this.where({ archivedAt: { eq: "null" } });
  }
}

export default UpsellRegistration;
